import ReactGA from 'react-ga4';
import { store } from 'store';

export const pageView = (page: string) => {
    const enabledGA = `${process.env.REACT_APP_ENABLE_GA}` === 'true';
    const cuddlesGATrackingID = `${process.env.REACT_APP_CUDDLES_GA_TRACKING_ID}`;
    const marketplace = store.getState().marketplace.marketplace;
    const auth = store.getState().login.auth;

    if (enabledGA) {
        if (!ReactGA.isInitialized || ReactGA._currentMeasurementId !== cuddlesGATrackingID) {
            ReactGA.reset();

            if (auth.signedIn) {
                ReactGA.initialize(cuddlesGATrackingID);
                ReactGA._gtag('config', cuddlesGATrackingID, { user_id: marketplace.id });
            }
        }

        ReactGA.send({ hitType: 'pageview', page });
    }
};
